import StorefrontCategoryTree from '@local-types/categoryTrees/storefrontCategoryTree'
import { getCategoryInTreeByProperty } from './urlHelperFunctions'

export const getTreeFilterSlugFromId = (id: string, trees: StorefrontCategoryTree[]): string => {
	if (!trees || trees.length <= 0) return id
	for (let i = 0; i < trees.length; i++) {
		for (let u = 0; u < trees[i].children.length; u++) {
			const element = trees[i].children[u]
			const category = getCategoryInTreeByProperty('id', id, element)
			if (category !== null) return category.slug
		}
	}
	return id
}

export const getTreeFilterIdFromSlug = (slug: string, trees: StorefrontCategoryTree[]): string => {
	if (!trees || trees.length <= 0) return slug
	for (let i = 0; i < trees.length; i++) {
		for (let u = 0; u < trees[i].children.length; u++) {
			const element = trees[i].children[u]
			const category = getCategoryInTreeByProperty('slug', slug, element)
			if (category !== null) return category.id
		}
	}
	return slug
}
